module.exports = __webpack_public_path__ + "static/media/p4.a317dfc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/urbanhipster/p4.jpg
// module id = 2938
// module chunks = 0